import { render, staticRenderFns } from "./MyElPopconfirm.vue?vue&type=template&id=373468c4"
import script from "./MyElPopconfirm.vue?vue&type=script&lang=js"
export * from "./MyElPopconfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports